import axios from 'axios';

// export const baseURL='http://localhost:8020'
//  export const baseURL='https://abc.smbmhs.cn'
export const baseURL='http://localhost:8020'


// 
const instance = axios.create({
	baseURL,
	timeout: 1000000
})

instance.interceptors.request.use(config => {
	// 如果是文件上传请求,不设置 Content-Type,让浏览器自动设置
	if (!(config.data instanceof FormData)) {
		config.headers['Content-Type'] = `application/json`
	}

	// 添加请求日志
	console.log('🌐 发送请求:', {
		url: config.url,
		method: config.method,
		data: config.data,
		headers: config.headers
	})

	return config
}, err => {
	return Promise.reject(err)
})



// 请求工具函数
export default (url, method, submitData, config = {}) => {
	// 负责发请求:请求地址,请求方式,提交的数据
	const requestConfig = {
		url,
		method,
		// 1. 如果是get请求  需要使用params来传递submitData   ?a=10&c=10
		// 2. 如果不是get请求  需要使用data来传递submitData   请求体传参
		// [] 设置一个动态的key, 写js表达式,js表达式的执行结果当作KEY
		// method参数:get,Get,GET  转换成小写再来判断
		// 在对象,['params']:submitData ===== params:submitData 这样理解
		[method.toLowerCase() === 'get' ? 'params' : 'data']: submitData,
		...config
	}
	
	// 如果 URL 是完整 URL (包含 http:// 或 https://),则使用 axios 直接请求
	if (url.startsWith('http://') || url.startsWith('https://')) {
		return axios(requestConfig)
	}
	
	// 否则使用配置了 baseURL 的 instance
	return instance(requestConfig)
}

// 添加响应拦截器
instance.interceptors.response.use(response => {
	console.log('📥 收到响应:', {
		url: response.config.url,
		status: response.status,
		data: response.data
	})
	return response
}, error => {
	console.error('❌ 请求失败:', {
		url: error.config?.url,
		status: error.response?.status,
		message: error.message,
		data: error.response?.data
	})
	return Promise.reject(error)
})
// #endif